import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetOptionTypeById = function (id) {
    return useApiCall(function (signal) { return api.configuration.apiConfigurationOptionTypeIdGet(id, { signal: signal }); }, null, !!id, [id]);
};
